/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Camera_RollInputs */

const en_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera Roll`)
};

const es_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carrete`)
};

const fr_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pellicule`)
};

const de_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aufnahmen`)
};

const ja_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カメラロール`)
};

const zh_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相机胶卷`)
};

const ar_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ألبوم الكاميرا`)
};

const id_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Galeri Kamera`)
};

const it_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rullino`)
};

const ru_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пленка`)
};

const pt_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolo da Câmera`)
};

const ko_camera_roll = /** @type {(inputs: Camera_RollInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`카메라 롤`)
};

/**
* | output |
* | --- |
* | "Camera Roll" |
*
* @param {Camera_RollInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const camera_roll = /** @type {((inputs?: Camera_RollInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Camera_RollInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_camera_roll(inputs)
	if (locale === "es") return es_camera_roll(inputs)
	if (locale === "fr") return fr_camera_roll(inputs)
	if (locale === "de") return de_camera_roll(inputs)
	if (locale === "ja") return ja_camera_roll(inputs)
	if (locale === "zh") return zh_camera_roll(inputs)
	if (locale === "ar") return ar_camera_roll(inputs)
	if (locale === "id") return id_camera_roll(inputs)
	if (locale === "it") return it_camera_roll(inputs)
	if (locale === "ru") return ru_camera_roll(inputs)
	if (locale === "pt") return pt_camera_roll(inputs)
	return ko_camera_roll(inputs)
});